import { Injectable } from '@angular/core';
import { UnsyncCachingService } from '../../../services.module';

@Injectable({
  providedIn: 'root'
})
export class CachingService {
  private lastActiveTabUrl: string = ''

  constructor(
    private unsyncCachingService: UnsyncCachingService
  ) {
    this.unsyncCachingService.init();
  }

  async getLastActiveTabUrl(): Promise<void> {
    try {
      // return await this.unsyncCachingService.getLastActiveTabUrl();
      return new Promise((resolve) => {
        resolve();
      })
    } catch (error) {
      console.log(error);
    }
  }

  async setLastActiveTabUrl(url: string): Promise<void> {
    try {
      return await this.unsyncCachingService.setLastActiveTabUrl(url);
    } catch (error) {
      console.log(error);
    }
  }
}
